/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function customerRevokeQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function customerRevokeInput(accountNum: string): IDataServiceRequest {
    const query = customerRevokeQuery();
    return query.createDataServiceRequestForOperation(
        'CustomerRevoke',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            accountNum: accountNum
        }
    );
}

export function customerRevokeAsync(context: IContext, accountNum: string): AsyncResult<boolean> {
    const request = customerRevokeInput(accountNum);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

function getCategoryDescriptionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCategoryDescriptionInput(categoryId: number, locale: string): IDataServiceRequest {
    const query = getCategoryDescriptionQuery();
    return query.createDataServiceRequestForOperation(
        'GetCategoryDescription',
        false,
        DataServiceEntities.CategoryExtendedExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICategoryExtended' },
        {
            CategoryId: categoryId,
            Locale: locale
        }
    );
}

export function getCategoryDescriptionAsync(
    context: IContext,
    categoryId: number,
    locale: string
): AsyncResult<DataServiceEntities.ICategoryExtended> {
    const request = getCategoryDescriptionInput(categoryId, locale);
    return callActionOrExecute<DataServiceEntities.ICategoryExtended>(request, context.callerContext);
}

function getCustomerAttributesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCustomerAttributesInput(queryResultSettings: IQueryResultSettings, language: string): IDataServiceRequest {
    const query = getCustomerAttributesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetCustomerAttributes',
        true,
        DataServiceEntities.MOECustomerAttributeExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMOECustomerAttribute' },
        {
            language: language
        }
    );
}

export function getCustomerAttributesAsync(context: IContext, language: string): AsyncResult<DataServiceEntities.IMOECustomerAttribute[]> {
    const request = getCustomerAttributesInput(context.queryResultSettings || {}, language);
    return callActionOrExecute<DataServiceEntities.IMOECustomerAttribute[]>(request, context.callerContext);
}

function getDefaultCustomerDetailsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getDefaultCustomerDetailsInput(): IDataServiceRequest {
    const query = getDefaultCustomerDetailsQuery();
    return query.createDataServiceRequestForOperation(
        'GetDefaultCustomerDetails',
        false,
        DataServiceEntities.DefaultAddressEmailExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IDefaultAddressEmail' },
        {}
    );
}

export function getDefaultCustomerDetailsAsync(context: IContext): AsyncResult<DataServiceEntities.IDefaultAddressEmail> {
    const request = getDefaultCustomerDetailsInput();
    return callActionOrExecute<DataServiceEntities.IDefaultAddressEmail>(request, context.callerContext);
}

function getDigitalNZDetailsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getDigitalNZDetailsInput(searchText: string, page: number): IDataServiceRequest {
    const query = getDigitalNZDetailsQuery();
    return query.createDataServiceRequestForOperation(
        'GetDigitalNZDetails',
        false,
        DataServiceEntities.DigitalNZExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IDigitalNZ' },
        {
            searchText: searchText,
            page: page
        }
    );
}

export function getDigitalNZDetailsAsync(context: IContext, searchText: string, page: number): AsyncResult<DataServiceEntities.IDigitalNZ> {
    const request = getDigitalNZDetailsInput(searchText, page);
    return callActionOrExecute<DataServiceEntities.IDigitalNZ>(request, context.callerContext);
}

function getMOEOnlineStoresQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getMOEOnlineStoresInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = getMOEOnlineStoresQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetMOEOnlineStores',
        false,
        DataServiceEntities.MOEChannelExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMOEChannel' },
        {}
    );
}

export function getMOEOnlineStoresAsync(context: IContext): AsyncResult<DataServiceEntities.IMOEChannel[]> {
    const request = getMOEOnlineStoresInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IMOEChannel[]>(request, context.callerContext);
}

function getMOEWishListQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getMOEWishListInput(
    queryResultSettings: IQueryResultSettings,
    id: number,
    customerAccountNumber: string,
    favoriteFilter: boolean,
    publicFilter: boolean
): IDataServiceRequest {
    const query = getMOEWishListQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetMOEWishList',
        false,
        DataServiceEntities.MOECommerceListExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMOECommerceList' },
        {
            Id: id,
            CustomerAccountNumber: customerAccountNumber,
            FavoriteFilter: favoriteFilter,
            PublicFilter: publicFilter
        }
    );
}

export function getMOEWishListAsync(
    context: IContext,
    id: number,
    customerAccountNumber: string,
    favoriteFilter: boolean,
    publicFilter: boolean
): AsyncResult<DataServiceEntities.IMOECommerceList[]> {
    const request = getMOEWishListInput(context.queryResultSettings || {}, id, customerAccountNumber, favoriteFilter, publicFilter);
    return callActionOrExecute<DataServiceEntities.IMOECommerceList[]>(request, context.callerContext);
}

function moeSearchProductsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function moeSearchProductsInput(
    queryResultSettings: IQueryResultSettings,
    searchCriteria: Entities.ProductSearchCriteria
): IDataServiceRequest {
    const query = moeSearchProductsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'MoeSearchProducts',
        true,
        DataServiceEntities.MoeSearchProductExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMoeSearchProduct' },
        {
            searchCriteria: searchCriteria
        }
    );
}

export function moeSearchProductsAsync(
    context: IContext,
    searchCriteria: Entities.ProductSearchCriteria
): AsyncResult<DataServiceEntities.IMoeSearchProduct[]> {
    const request = moeSearchProductsInput(context.queryResultSettings || {}, searchCriteria);
    return callActionOrExecute<DataServiceEntities.IMoeSearchProduct[]>(request, context.callerContext);
}

function getArtifactsByItemQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getArtifactsByItemInput(queryResultSettings: IQueryResultSettings, itemId: string): IDataServiceRequest {
    const query = getArtifactsByItemQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetArtifactsByItem',
        false,
        DataServiceEntities.ArtifactsExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IArtifacts' },
        {
            ItemId: itemId
        }
    );
}

export function getArtifactsByItemAsync(context: IContext, itemId: string): AsyncResult<DataServiceEntities.IArtifacts[]> {
    const request = getArtifactsByItemInput(context.queryResultSettings || {}, itemId);
    return callActionOrExecute<DataServiceEntities.IArtifacts[]>(request, context.callerContext);
}

function validateCustomerDetailsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function validateCustomerDetailsInput(emailId: string): IDataServiceRequest {
    const query = validateCustomerDetailsQuery();
    return query.createDataServiceRequestForOperation(
        'ValidateCustomerDetails',
        false,
        DataServiceEntities.ValidCustomerExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IValidCustomer' },
        {
            emailId: emailId
        }
    );
}

export function validateCustomerDetailsAsync(context: IContext, emailId: string): AsyncResult<DataServiceEntities.IValidCustomer> {
    const request = validateCustomerDetailsInput(emailId);
    return callActionOrExecute<DataServiceEntities.IValidCustomer>(request, context.callerContext);
}
